import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export interface StorageChemistryOption {
  value: number;
  label: string;
}

const STORAGE_CHEMISTRIES_STALE_TIME = 1000 * 60 * 60 * 24; // 24 hours

export const storageChemistryKeys = {
  all: ['storage-chemistries'] as const,
};

export const useStorageChemistriesQuery = () => {
  return useQuery({
    queryKey: storageChemistryKeys.all,
    queryFn: async () => {
      const { data } = await client.get<{ body: StorageChemistryOption[] }>(
        '/services/storage-chemistries'
      );
      return data.body;
    },
    staleTime: STORAGE_CHEMISTRIES_STALE_TIME,
    gcTime: STORAGE_CHEMISTRIES_STALE_TIME,
  });
};
